import React from 'react';
import ReactResizeObserver from '../_util/resizeObserver';
const PopupInner = ({ innerRef, onResize, ...props }) => (React.createElement(ReactResizeObserver, { onResize: onResize },
    React.createElement("div", Object.assign({}, props, { ref: innerRef }))));
export default PopupInner;
